import { Button, Container, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { Routes } from 'constants/routes.constants';

import StickyButtonContainer from 'components/@saudi-rewards/SaudiRewardsRetroRedeemContainer/StickyButtonContainer';

const SaudiRewardsRetroRedeemClosedContainer = () => {
  return (
    <Container
      maxWidth="xs"
      sx={{ mt: 1, display: 'flex', flexDirection: 'column', flexGrow: 1 }}
    >
      <Stack sx={{ flexGrow: { xs: 1, md: 0 } }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          <FormattedMessage id="claim.points.closed.title" />
        </Typography>
        <Typography variant="small" sx={{ mb: 3 }}>
          <FormattedMessage id="claim.points.closed.description" />
        </Typography>
      </Stack>

      <StickyButtonContainer>
        <Button
          href={Routes.Home}
          variant="outlined"
          color="secondary"
          sx={{ width: { xs: '100%', md: 'fit-content' } }}
        >
          <FormattedMessage id="error.back.home.link" />
        </Button>
      </StickyButtonContainer>
    </Container>
  );
};

export default SaudiRewardsRetroRedeemClosedContainer;
